import React, { Component } from 'react'
import { Rnd } from 'react-rnd'
import GanttTaskInfo from './gantt-task-info'

export default class GanttChartBar extends Component {
	state = {
		isInfoVisible: false,
		infoDirection: 'down',
		taskStart: null
	}

	barRef = null
	barComponentRef = null

	handleHover = isHovered => {
		const {
			interactedTaskId,
			chartRefOffsets,
			setHover
		} = this.props

		if (interactedTaskId) {
			return
		}

		if (isHovered) {
			setHover(true)
		} else {
			setHover(false)
		}

		const barRect = this.barRef.getBoundingClientRect()

		const offsetFromLeft = barRect.left - chartRefOffsets.left
		const offsetFromRight = chartRefOffsets.right - barRect.right

		let direction = 'down'

		if (offsetFromLeft < 100) {
			direction = 'right'
		} else if (offsetFromRight < 100) {
			direction = 'left'
		}

		this.setState({
			isInfoVisible: isHovered,
			infoDirection: direction
		})
	}

	componentDidUpdate = _ => {
		const {
			taskStart
		} = this.props

		if (this.barComponentRef) {
			const actualLeft = this.barComponentRef.draggable.state.x

			if (actualLeft != taskStart) {
				this.barComponentRef.updatePosition({
					x: taskStart,
					y: 0
				})
			}
		}
	}

	render() {
		const {
			currentProject,
			cellWidth,
			taskStart,
			taskWidth,
			handleMoveTask,
			toggleDragOrResize,
			handleResizeTask,
			task,
			setInteractedTaskId,
			interactedTaskId,
			setHover,
			hoveredRow
		} = this.props

		const {
			isInfoVisible,
			infoDirection,
		} = this.state

		const itemLength = task.endIndex - task.startIndex

		let barClassName = (interactedTaskId && interactedTaskId !== task.id) ? 'no-hover' : ''

		if (itemLength < 2) {
			barClassName += ' single-date'
		}

		return (
			<Rnd
				className={barClassName}
				default={{
					x: taskStart,
					y: 0,
					width: taskWidth,
					height: 20
				}}
				resizeGrid={[cellWidth, 20]}
				dragGrid={[cellWidth, 40]}
				enableResizing={{
					bottom: false,
					bottomLeft: false,
					bottomRight: false,
					left: true,
					right: true,
					topLeft: false,
					topRight: false,
					top: false
				}}
				dragAxis={'x'}
				onResizeStart={e => {
					toggleDragOrResize('start', e, task.id)
				}}
				onResizeStop={(e, dir, ref, delta, pos) => {
					handleResizeTask(task.id, dir, delta.width)
					setInteractedTaskId(null)
					toggleDragOrResize('stop')
					setHover(false)
				}}
				onDragStart={(e, data) => {
					// move this to a method, then don't allow info modal when dragging (and keep hover styles)
					toggleDragOrResize('start', e, task.id)
					handleMoveTask('start', task.id, data)
					this.setState({
						isInfoVisible: false
					})
				}}
				onDragStop={(e, data) => {
					setInteractedTaskId(null)
					handleMoveTask('stop', task.id, data)
					toggleDragOrResize('stop', null, task.id)
					setHover(false)
				}}
				onMouseEnter={_ => {
					this.handleHover(true)
				}}
				onMouseLeave={_ => {
					this.handleHover(false)
				}}
				ref={ref => {
					this.barComponentRef = ref
				}}
			>
				<div
					className="position-ref"
					ref={ref => this.barRef = ref}
				/>
				<GanttTaskInfo
					currentProject={currentProject}
					isVisible={isInfoVisible}
					task={task}
					direction={infoDirection}
				/>
			</Rnd>
		)
	}
}
